import React, { Component } from 'react';
import { Paper, Typography } from "@material-ui/core";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { connect } from 'react-redux';

class SystemDeviceFaultsPieChartErrors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartOptions: {
                chart: {
                    type: 'pie',
                    backgroundColor: null // Use default white background
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.y}',
                            style: {
                                color: 'black' 
                              }
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    name: 'Error Count',
                    colorByPoint: true,
                    data: []
                }],
                credits: {
                    enabled: false
                }
            }
        };
    }

    componentDidMount() {
        this.processData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stationDeviceFaultData !== this.props.stationDeviceFaultData) {
            this.processData();
        }
    }

    processData = () => {
        const { deviceFaults } = this.props.stationDeviceFaultData;
        const errorCounts = {};
        const statusErrorCounts = {};
    
        deviceFaults.forEach(fault => {
            // Count error codes that are not "Not Error"
            fault.errorCodes?.forEach(error => {
                const errorCode = error.errorCode;
                if (errorCode !== "Not Error") {
                    errorCounts[errorCode] = (errorCounts[errorCode] || 0) + 1;
                }
            });
    
            // Count device status as errors only if the errorCode is "Not Error" and the status contains "Error"
            if (fault.errorCodes?.some(e => e.errorCode === "Not Error")) {
                fault.deviceStatus?.forEach(status => {
                    let deviceStatus = status.status;
                    
                    // Skip statuses that are explicitly marked as "Not Error"
                    if (deviceStatus.includes("Not Error")) return;
    
                    // Assuming a status with "Error" indicates an actual fault
                    if (deviceStatus.includes("Error")) {
                        // Remove the word "Error" from the status
                        deviceStatus = deviceStatus.replace("Error", "").trim();
                        statusErrorCounts[deviceStatus] = (statusErrorCounts[deviceStatus] || 0) + 1;
                    }
                });
            }
        });
    
        // Prepare chart data with both error codes and device status errors
        const chartData = [
            ...Object.keys(errorCounts).map(errorCode => ({
                name: errorCode,
                y: errorCounts[errorCode]
            })),
            ...Object.keys(statusErrorCounts).map(status => ({
                name: status, // Status with "Error" removed
                y: statusErrorCounts[status]
            }))
        ];
    
        this.setState({
            chartOptions: {
                ...this.state.chartOptions,
                series: [{
                    name: 'Error Counts',
                    data: chartData
                }]
            }
        });
    };            

    render() {
        const { loading } = this.props.stationDeviceFaultData;
        const hasData = this.state.chartOptions.series[0].data.length > 0;

        return (
            <Paper className="SmartOMInfo">
                <div style={{ overflowX: 'auto' }}>
                    {!loading && hasData ? (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.state.chartOptions}
                        />
                    ) : (
                        <Typography variant="subtitle1" style={{ margin: '20px' }}>
                            Data not available. Please submit to see the Frequency Pie Chart.
                        </Typography>
                    )}
                </div>
             </Paper>
        );
    }
}

const mapStateToProps = (state) => ({
    stationDeviceFaultData: state.systemDeviceFaults.queryDeviceFaultData
});

export default connect(mapStateToProps)(SystemDeviceFaultsPieChartErrors);
